<template>

  <!-- <b-breadcrumb :items="breadcrumbs" /> -->
  <b-breadcrumb>
    <template v-for="(item, index) in breadcrumbs">
      <template v-if="item.click">
        <b-breadcrumb-item v-if="item.text" :key="index" @click.prevent.stop="item.click">{{ item.text }}</b-breadcrumb-item>
      </template>
      <template v-else>
        <b-breadcrumb-item v-if="item.text" :key="index" :to="item.to">{{ item.text }}</b-breadcrumb-item>
      </template>
    </template>
  </b-breadcrumb>

</template>

<script>
export default {
  name: 'BootBread',
  props: {
    customBreadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breadcrumbs () {
      if (this.customBreadcrumbs.length) {
        return [...this.customBreadcrumbs, {
          text: '',
          to: { name: '' }
        }]
      }

      const route = this.$route
      const breadcrumbs = []

      const currentMatched = route.matched.slice(-1)[0]

      if (currentMatched && currentMatched.meta?.breadcrumb) {
        this.buildBreadcrumbs(currentMatched, breadcrumbs, true)
      }
      return breadcrumbs
    }
  },
  methods: {
    buildBreadcrumbs (route, breadcrumbs, isCurrent = false) {
      if (!route?.meta?.breadcrumb) return

      if (route.meta.breadcrumb.parent) {
        const parentRoute = this.findRouteByName(route.meta.breadcrumb.parent)
        if (parentRoute) {
          this.buildBreadcrumbs(parentRoute, breadcrumbs, false)
        }
      }

      if (isCurrent) {
        breadcrumbs.push({
          text: '',
          to: null
        })
      } else {
        breadcrumbs.push({
          text: route.meta.breadcrumb.label,
          to: { name: route.name }
        })
      }
    },

    findRouteByName (name) {
      const stack = [...this.$router.options.routes]
      while (stack.length) {
        const route = stack.pop()
        if (route.name === name) return route
        if (route.children) stack.push(...route.children)
      }
      return null
    }
  }
}
</script>
